<template>
    
    <div>
        <Dialog v-model:visible="visible" modal header="CPF" :style="{ width: '50vw' }" :closable="false">

            <table v-for="d in droitsCpf" :key="d.id">
                <tr>CPF - {{ d.tot }} € - {{ d.payeur }}</tr>
                <tr>
                    <th>Date</th>
                    <th>Nature</th>
                    <th>montant</th>
                </tr>
                <tr>
                    <td>{{ new Date(d.date.date).toLocaleDateString('fr-FR') }}</td>
                    <td>{{ d.description }}</td>
                    <td>{{ d.ini }} €</td>
                </tr>
                <tr v-for="a in d.acptes" :key="a.id">
                    <td>{{ new Date(a.date.date).toLocaleDateString('fr-FR') }}</td>
                    <td>{{ a.description }}</td>
                    <td>- {{ a.tot }} €</td>
                </tr>
            </table>

            <template #footer>
                <button @click="close" class="btn btn-primary">CLOSE</button>
            </template>
        </Dialog>
    </div>
</template>

<script>
export default {
    props: ["boolean", "droitCpf", "acpteCpf"],

    whatch: {
        visible(newValue){
            this.$emit("cancelCpfDetail", newValue);
        }
    },

    data() {
        return {
            visible : this.boolean,
            droitsCpf : this.droitCpf,
            acptesCpf : this.acpteCpf,
        }
    },

    mounted() {
        this.calculTotDroits();
    },

    methods: {
        close(){
            this.visible = false;
            this.$emit("cancelCpfDetail", false);
        },

        calculTotDroits(){
            this.droitsCpf.forEach(d => {
                let totCpf = 0;
                totCpf = totCpf + d.tot;

                d.acptes = [];

                this.acptesCpf.forEach(a => {
                    if(d.id == a.doitsCpfId){
                        totCpf = totCpf + a.tot;
                        d.acptes.push(a);
                    }
                })

                d.ini = totCpf;

            });
        }
    },
}
</script>


<style scoped>
table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

table td, table th {
  border: 1px solid #ddd;
  padding: 8px;
}

table tr:nth-child(even){background-color: #f2f2f2;}

table tr:hover {background-color: #ddd;}

table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #07989f;
  color: white;
}
</style>